import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));

const walletSubdomain = window.location.hostname.toLowerCase() === "wallet.holapay.it";
const walletBasePath = "/alpha-pay";
const currentPath = window.location.pathname || "/";
const alreadyOnWalletApp = currentPath.startsWith(`${walletBasePath}/`);
const offlineUsdaReviewPreview =
  process.env.NODE_ENV === "development" &&
  currentPath.endsWith("/__offline/usda-review");
const offlineAdminMerchantPreview =
  process.env.NODE_ENV === "development" &&
  currentPath.endsWith("/__offline/admin-merchant-lookup");

if (offlineUsdaReviewPreview) {
  const OfflineUsdaReviewPreview = React.lazy(
    () => import("./preview/UsdaReviewOfflinePreview"),
  );
  root.render(
    <React.Suspense fallback={<div className="p-8">Caricamento anteprima offline…</div>}>
      <OfflineUsdaReviewPreview />
    </React.Suspense>,
  );
} else if (offlineAdminMerchantPreview) {
  const OfflineAdminMerchantPreview = React.lazy(
    () => import("./preview/AdminMerchantLookupOfflinePreview"),
  );
  root.render(
    <React.Suspense fallback={<div className="p-8">Caricamento anteprima offline…</div>}>
      <OfflineAdminMerchantPreview />
    </React.Suspense>,
  );
} else if (walletSubdomain && !alreadyOnWalletApp) {
  const walletPath = currentPath === "/" || currentPath === walletBasePath
    ? `${walletBasePath}/`
    : `${walletBasePath}${currentPath}`;
  window.location.replace(`${walletPath}${window.location.search}${window.location.hash}`);
} else {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}
